import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("team@theluxbel.com");
  const [password, setPassword] = useState("luxbel2026");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back to the studio");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0C] grain flex items-center justify-center px-6 relative z-[2]">
      <div className="w-full max-w-md fade-up">
        <div className="text-center mb-10">
          <div className="font-serif text-3xl tracking-[0.35em] mb-3">LUXBEL</div>
          <p className="overline">Team Review Studio</p>
        </div>
        <form onSubmit={submit} className="space-y-5 bg-[#141417] border border-white/10 rounded-sm p-8" data-testid="admin-login-form">
          <div>
            <label className="text-xs font-mono uppercase tracking-[0.15em] text-[#8E8E9A]">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-2 bg-[#0B0B0C] border border-white/15 rounded-sm px-4 py-3 text-[#F8F6F0] focus:border-[#D4AF37] outline-none transition-colors"
            />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-[0.15em] text-[#8E8E9A]">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-2 bg-[#0B0B0C] border border-white/15 rounded-sm px-4 py-3 text-[#F8F6F0] focus:border-[#D4AF37] outline-none transition-colors"
            />
          </div>
          <button
            data-testid="login-submit-button"
            disabled={loading}
            className="w-full bg-[#D4AF37] text-black py-3 rounded-sm font-medium tracking-wide hover:bg-[#C5A059] transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Enter Studio"}
          </button>
        </form>
      </div>
    </div>
  );
}
